export default __webpack_public_path__ + "static/media/driver_carrier.ce771e47.png";